import React from "react";
import toast from "react-hot-toast";

import api from "../../../../services/api";
import Comments from "../../../../components/Comments";

export default ({ values, setValues, currentUser }) => {
  const handleAddComment = async (text) => {
    const comment = { text, user_id: currentUser._id, user_name: currentUser.name, user_avatar: currentUser.avatar, created_at: new Date() };
    try {
      const { data, ok } = await api.put(`/budget/${values._id}`, { comments: [...(values.comments || []), comment] });
      if (!ok) return toast.error("Failed to add comment");
      setValues((prev) => ({ ...prev, comments: data.comments }));
    } catch (error) {
      console.error(error);
      toast.error("Failed to add comment");
    }
  };

  const handleDeleteComment = async (comment_id) => {
    try {
      const { data, ok } = await api.put(`/budget/${values._id}`, { comments: (values.comments || []).filter((comment) => comment._id !== comment_id) });
      if (!ok) return toast.error("Failed to delete comment");
      setValues((prev) => ({ ...prev, comments: data.comments }));
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete comment");
    }
  };

  return (
    <div className="bg-white border border-gray-300 rounded p-4">
      <h3 className="text-lg font-semibold mb-4">Comments</h3>
      <Comments value={values.comments || []} onAdd={handleAddComment} onDelete={handleDeleteComment} />
    </div>
  );
};
